export default __webpack_public_path__ + "static/media/gallery_02.9a83be71.jpg";